import { notificationApi } from "@/core/data/api";

export default async (id) => {
  return await notificationApi.updateNotification(id, { isRead: true });
};
